import { ViewCreator } from './ViewCreator';
import React, { Fragment } from 'react';
import { Typography } from '@mui/material';
import { AcceptInviteView } from '../views/AcceptInviteView';
import { InviteCodeValidator } from '../validators/InviteCodeValidator';

export interface AcceptInviteArgs {
  inviteCode: string | null;
}

export class AcceptInviteViewCreator extends ViewCreator<AcceptInviteView, AcceptInviteArgs> {
  createView: () => AcceptInviteView;
  createViewWithArg: (arg: { inviteCode: string | null }) => AcceptInviteView;

  constructor() {
    super();
    this.createView = () => {
      throw new Error('Method not implemented');
    };

    this.createViewWithArg = ({ inviteCode }) => {
      const validationErrors = new InviteCodeValidator().validate({
        inviteCode: inviteCode,
      });
      if (validationErrors.inviteCode) {
        return {
          loginEnabled: false,
          validationErrors: validationErrors,
          authRedirectUrl:
            (import.meta.env.VITE_APP_BASE_SERVER_URL || 'http://localhost:3000') + `/auth?state=${inviteCode}`,
          loginButtonHelp: (
            <Fragment>
              <Typography color={'inherit'}>{validationErrors.inviteCode}</Typography>
            </Fragment>
          ),
        };
      }

      return {
        loginEnabled: true,
        authRedirectUrl:
          (import.meta.env.VITE_APP_BASE_SERVER_URL || 'http://localhost:3000') + `/auth?state=${inviteCode}`,
        loginButtonHelp: '',
      };
    };
  }
}

const viewCreator = new AcceptInviteViewCreator();
const defaultExport = { ViewCreator: viewCreator };
export default defaultExport;
